/* eslint-disable jsx-a11y/label-has-associated-control */
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import { getAsync, putAsync } from '../../../../components/helper/axiosHelper';
import { handleFileDownload } from '../../../../libs';
import { DetailAccordion } from '../../../external/service/sd/DetailAccordion';
import { useLocation } from 'react-router-dom';
import { PageHitCountApi } from '../../../../shared/Helper';
const SDReport = () => {
  const { id } = useParams();
  const [eP_ID, setEP_ID] = useState('');

  const [apiData, setApiData] = useState([]);
  const [mediaData, setMediaData] = useState([]);
  const [serviceDeadID, setServiceDeadID] = useState(0);
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [reason, setReason] = useState('');
  const [limitRequest, setLimitRequest] = useState(true);
  const [password, setPassword] = useState('');
  const [isLoad, setIsLoad] = useState(false);
  const { pathname } = useLocation()

  const { t } = useTranslation();
  const navigate = useNavigate();

  const token = localStorage.getItem('token');
  const epUser = localStorage.getItem('apid');
  const isLogin = () => {
    if (!token) {
      navigate('/managementLogin');
    }
  };


  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, [])

  useEffect(() => {
    localStorage.setItem('isHome', false);
    isLogin();
    getData();
    // eslint-disable-next-line
  }, []);

  let axiosConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const getData = async () => {
    setIsLoad(true);
    await getAsync('ServiceDead/GetSDByIDAsync/', { id: id })
      .then((response) => {
        setIsLoad(false);
        const result = response?.data[0];
        setMediaData(result?.archiveMediaModelList);
        setApiData(result);
      })
      .catch((err) => {
        toast.error(t('Record not found'));
      });
  };

  const validate = () => {
    let result = true;
    if (password === '' || password === null) {
      result = false;
      toast.warning(`${t('msg_pleaseEnter')}` + `${t('password')}`);
    }
    return result;
  };

  var localeDateTime = new Date();
  const bodyApprove = {
    ePUserID: epUser,
    serviceDeadID: parseInt(serviceDeadID),
    maID: 1,
    maApproveID: 1,
    maDate: localeDateTime,
    reason: reason,
    password: password,
    activeID: 1,
  };

  const handleApprove = async (e) => {
    e.preventDefault();
    if (validate) {
      await putAsync('ServiceDead/SDApproval/' + id, bodyApprove, axiosConfig)
        .then((response) => {
          if (response !== 'Password Failed!') {
            toast.success(`${t('msg_recordSuccessUpdate')}`);
            getData();
            navigate('/SDProjectApprovalList');
          } else {
            toast.error(`${t('msg_recordFailedUpdate Password is incorrect')}`);
          }
        })
        .catch((err) => {
          toast.error(t('Something went wrong, Please try again!'));
        });
    }
  };

  const openModal = (e, data) => {
    e.preventDefault();
    setGridModalOpen(true);
  };

  const closeModal = (e) => {
    e.preventDefault();
    setGridModalOpen(false);
  };

  const handleDocLoad = async (e) => {
    e.preventDefault();
    await getData();
    setLimitRequest(false);
  };

  const handleEP_IdDownload = async (e, base64Data, fileName) => {
    try {
      e.preventDefault();

      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const fileBlob = new Blob([byteArray], { type: 'image/*' });
      const fileUrl = URL.createObjectURL(fileBlob);
      const img = document.createElement('img');
      img.src = fileUrl;
      document.body.appendChild(img);
      const downloadLink = document.createElement('a');
      downloadLink.download = fileName;
      downloadLink.href = fileUrl;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      document.body.removeChild(img);
      URL.revokeObjectURL(fileUrl);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const handleEP_DeadCertificateDownload = async (e, base64Data, fileName) => {
    try {
      e.preventDefault();

      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const fileBlob = new Blob([byteArray], { type: 'image/*' });
      const fileUrl = URL.createObjectURL(fileBlob);
      const img = document.createElement('img');
      img.src = fileUrl;
      document.body.appendChild(img);
      const downloadLink = document.createElement('a');
      downloadLink.download = fileName;
      downloadLink.href = fileUrl;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      document.body.removeChild(img);
      URL.revokeObjectURL(fileUrl);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const handleEP_ApprovalLetterDownload = async (e, base64Data, fileName) => {
    try {
      e.preventDefault();

      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const fileBlob = new Blob([byteArray], { type: 'image/*' });
      const fileUrl = URL.createObjectURL(fileBlob);
      const img = document.createElement('img');
      img.src = fileUrl;
      document.body.appendChild(img);
      const downloadLink = document.createElement('a');
      downloadLink.download = fileName;
      downloadLink.href = fileUrl;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      document.body.removeChild(img);
      URL.revokeObjectURL(fileUrl);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  return (
    <>
      <div className="container-fluid  ">
        {isLoad ? (
          <LoadingAnimation />
        ) : (
          <div className="row justify-center py-5 mt-3">
            <div className="col-xl-11">
              <form>
                <div className="shadow-md  rounded-md">
                  <div className="card-header">
                    <h3
                      className="font-bold sm:text-2xl text-customgreen text-xl  py-3"
                      style={{ textAlign: 'center' }}
                    >
                      {t('Service For Dead Report List View')}
                    </h3>
                  </div>
                  <div className="card-body md:p-10">
                    <div className="row">
                      <div className="col-lg-12">
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            {/* <Typography style={{ fontWeight: 'bold', fontSize: '18px' }}>{t('Details')}</Typography> */}
                            <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Details')}</h2>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography></Typography>
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label className="text-gray-700 p-2  text-pretty text-sm">
                                    {t('Name of Dead Person')}
                                    <span className="errmsg">*</span>
                                  </label>
                                  <input
                                    value={apiData?.deadName}
                                    type="text"
                                    disabled
                                    style={{
                                      cursor: 'no-drop',
                                    }}
                                    className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                    minLength="1"
                                    maxLength="50"
                                  />
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label className="text-gray-700 p-2  text-pretty text-sm">
                                    {t('Project Name')}
                                    <span className="errmsg">*</span>
                                  </label>
                                  <input
                                    value={apiData?.newProjectName}
                                    disabled
                                    style={{
                                      cursor: 'no-drop',
                                    }}
                                    type="text"
                                    className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                    minLength="1"
                                    maxLength="100"
                                  />
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label className="text-gray-700 p-2  text-pretty text-sm">
                                    {t('Relationship')}
                                    <span className="errmsg">*</span>
                                  </label>
                                  <input
                                    value={t(`${apiData?.relationName}`)}
                                    disabled
                                    style={{
                                      cursor: 'no-drop',
                                    }}
                                    type="text"
                                    className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  />

                                  {/* { relationAPIData?.map((item, index) => (
                                        <option key={ index + 1 } value={ item.relationID }>
                                          { item.en_US }
                                        </option>
                                      )) } */}
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label className="text-gray-700 p-2  text-pretty text-sm">
                                    {t('Applicant Mobile')}
                                    <span className="errmsg">*</span>
                                  </label>
                                  <input
                                    value={apiData?.applicantMobile}
                                    disabled
                                    style={{
                                      cursor: 'no-drop',
                                    }}
                                    type="text"
                                    className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                    minLength="1"
                                    maxLength="20"
                                  />
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label className="text-gray-700 p-2  text-pretty text-sm">
                                    {t('Applicant Name')}
                                    <span className="errmsg">*</span>
                                  </label>
                                  <input
                                    value={apiData?.applicantName}
                                    disabled
                                    style={{
                                      cursor: 'no-drop',
                                    }}
                                    type="text"
                                    className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                    minLength="1"
                                    maxLength="50"
                                  />
                                </div>
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                        <br />

                        <DetailAccordion
                          limitRequest={limitRequest}
                          handleDocLoad={handleDocLoad}
                          mediaData={mediaData}
                          handleFileDownload={handleFileDownload}
                          title={'Document Details'}
                          eP_ID={eP_ID}
                        />
                        <br />

                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            {/* <Typography style={{ fontWeight: 'bold', fontSize: '18px' }}>{t('Extra')}</Typography> */}
                            <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Extra')}</h2>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography></Typography>
                            <div className="col-lg-12">
                              <div className="form-group">
                                <label className="text-gray-700 p-2  text-pretty text-sm">
                                  {t('Reason')} <span className="errmsg">*</span>
                                </label>
                                <textarea
                                  style={{
                                    cursor: 'no-drop',
                                    height: '200px',
                                  }}
                                  value={apiData?.reason}
                                  disabled
                                  className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  minLength="1"
                                  maxLength="500"
                                />
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                        <br />
                      </div>
                    </div>
                  </div>
                  <div className="card-footer md:px-10 py-2">
                    <Link
                      to={'/SDReportList'}
                      className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full w-20 text-sm px-2 py-2.5 text-center"
                    >
                      {t('Back')}
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SDReport;
